/**
 * Main Javascript imports
 */
import mobileMenu from './lib/mobile-navigation';
import listingFilters from './lib/listing-filter';
import loadMore from './lib/load-more.js';
import searchLogic from './lib/search-logic';
import submitForm from './lib/submit-form';
import modals from './lib/modal';
import notificationRibbon from './lib/notification-ribbon';

import $ from 'jquery';
import mapLogic from './lib/google-maps';
//Filters
listingFilters.initFilter('title');
listingFilters.initFilter('category');

//Load more functionality
loadMore.init();

// Google maps
$('.acf-map').each(function () {
  mapLogic.newMap($(this)); // create map
});

mobileMenu.initMenuControl();
searchLogic.initSearch();

//Modals
modals.initTermsModal();
modals.initAfterHoursModal();
modals.initNoticesModal();

//Notification Ribbon
notificationRibbon.initNotificationRibbon();

// remove preload class
window.addEventListener('load', () => {
  document.body.classList.remove('preload');
});

//Form Submit button
submitForm.initSubmit();
